/* eslint-disable @reatom/unit-naming-rule */

import { Result } from '@blade/std-lib'
import { pairRegistry } from '@root/entities/pair'
import { reatomDataTable } from '@root/shared/ui-kit'

import { createCreatorPairsTableColumns } from '../ui/creator-pairs-table/creator-pairs-table-columns'

import { fetchPairsByCreatorAction } from './creator-pairs-requests'

import type { Address } from '@root/entities/address/Address'
import type { Network } from '@root/entities/network'
import type { PairAddress, PairModel } from '@root/entities/pair'
import type { TableData } from '@root/shared/ui-kit'

export type CreatorPairsTableColumn =
  | 'pair'
  | 'createdAt'
  | 'migrated'
  | 'mcap'
  | 'ath'
  | 'liquidity'
  | 'holders'
  | 'pnl'
  | 'bondingCurveProgress'

export const reatomCreatorPairsTable = ({
  creatorAddress,
  network,
  excludePair,
}: {
  creatorAddress: Address
  network: Network.Network
  excludePair?: PairAddress
}) => {
  const tableModel = reatomDataTable<
    PairModel,
    CreatorPairsTableColumn,
    object,
    undefined
  >({
    columns: createCreatorPairsTableColumns(),
    getId: (it) => it.address,
    name: 'creator-pairs-table',
    loadItems: async (ctx, { pagination: { limit, cursor } }) => {
      const result = await fetchPairsByCreatorAction(ctx, {
        network,
        limit,
        cursor,
        creatorAddress,
      })

      const mappedResult = result.pipe(
        Result.map((data) => {
          const pairs = data.data
            .map((it) => {
              return pairRegistry.resolveFromDto(ctx, it)
            })
            .filter((it) => (excludePair ? it.address !== excludePair : true))

          const tableData: TableData<PairModel> = {
            data: pairs,
            cursor: data.meta.nextCursor,
            hasNext: data.meta.hasNext,
          }

          return tableData
        }),
      )

      return mappedResult
    },
  })

  return tableModel
}
export type CreatorPairsTableModel = ReturnType<typeof reatomCreatorPairsTable>
